/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ConfigChangeStartStopSageIntacctRecipesInput = {|
  sageIntacctTimeRegsFromForecast?: ?boolean,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type configChangeStartStopSageIntacctRecipesMutationVariables = {|
  input: ConfigChangeStartStopSageIntacctRecipesInput
|};
export type configChangeStartStopSageIntacctRecipesMutationResponse = {|
  +configChangeStartStopSageIntacctRecipes: ?{|
    +outcome: ?string
  |}
|};
export type configChangeStartStopSageIntacctRecipesMutation = {|
  variables: configChangeStartStopSageIntacctRecipesMutationVariables,
  response: configChangeStartStopSageIntacctRecipesMutationResponse,
|};
*/


/*
mutation configChangeStartStopSageIntacctRecipesMutation(
  $input: ConfigChangeStartStopSageIntacctRecipesInput!
) {
  configChangeStartStopSageIntacctRecipes(input: $input) {
    outcome
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "ConfigChangeStartStopSageIntacctRecipesInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfigChangeStartStopSageIntacctRecipesPayload",
    "kind": "LinkedField",
    "name": "configChangeStartStopSageIntacctRecipes",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "outcome",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "configChangeStartStopSageIntacctRecipesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "configChangeStartStopSageIntacctRecipesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "configChangeStartStopSageIntacctRecipesMutation",
    "operationKind": "mutation",
    "text": "mutation configChangeStartStopSageIntacctRecipesMutation(\n  $input: ConfigChangeStartStopSageIntacctRecipesInput!\n) {\n  configChangeStartStopSageIntacctRecipes(input: $input) {\n    outcome\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a2a838c0e0d3e6efa66f359db05223eb';

module.exports = node;
